'use strict';

(function () {
  'use strict';

  angular.module('referrals').component('referralForm', {
    bindings: {
      referralSettings: '<',
      user: '<',
      showListLink: '<',
      goBackFn: '<',
      completeFn: '<'
    },
    templateUrl: 'referrals/templates/referralForm.html',
    controller: ReferralFormCtrl
  });

  ReferralFormCtrl.$inject = ['$log', '$stateParams', '$q', 'nameRegex', 'providerSvc', 'referralSvc'];

  function ReferralFormCtrl($log, $stateParams, $q, nameRegex, providerSvc, referralSvc) {
    var vm = this;
    vm.nameValidation = nameRegex;
    vm.save = _save;
    vm.$onInit = function () {
      activate();
    };

    function activate() {
      $log.debug('activating ReferralFormCtrl');
      vm.isLoggedIn = !!vm.user;

      if (vm.user) {
        vm.referrerName = vm.user.firstName;
        vm.referrerEmailAddress = vm.user.emailAddress;
      }
      if (vm.referralSettings) {
        vm.organizationId = vm.referralSettings.organization.id;
        if (vm.referralSettings.accessCode) {
          vm.accessCodeId = vm.referralSettings.accessCode.id;
        }
      }
    }

    function _save() {
      if (!vm.form.$valid) {
        angular.forEach(vm.form, function (formElement) {
          if (formElement && formElement.hasOwnProperty('$dirty')) {
            formElement.$dirty = true;
          }
        });
        return;
      }
      var referralFields = {
        organizationId: vm.referralSettings.organization.id,
        accessCodeId: vm.referralSettings.accessCode ? vm.referralSettings.accessCode.id : null,
        settingsId: vm.referralSettings.settings.id,
        firstName: vm.firstName || null,
        emailAddress: vm.emailAddress || null,
        referrerName: vm.referrerName || null,
        referrerEmailAddress: vm.referrerEmailAddress || null,
        emailTemplate: vm.referralSettings.settings.templateName,
        source: 'INTERACTIVE',
        referralSentCount: 0,
        referralLastSentOn: null
      };

      //set access code id
      if (vm.referralSettings.settings.accessCodeChoiceEnabled) {
        if (vm.referralSettings.settings.accessCodeType === 'TEXT') {
          _resolveAccessCodeAndSend(providerSvc.getAccessCodeByName(vm.form.accessCodeChoice.$viewValue), referralFields);
        } else {
          _resolveAccessCodeAndSend(providerSvc.getAccessCodeById(vm.form.accessCodeChoice.$viewValue.accessCodeId), referralFields);
        }
      } else {
        //prevent double clicks
        vm.saving = true;
        _sendReferral(referralFields);
      }
    }

    function _resolveAccessCodeAndSend(accessCodePromise, referralFields) {
      accessCodePromise.then(function (resp) {
        referralFields.accessCodeId = resp.data.id;
        //prevent double clicks
        vm.saving = true;
        _sendReferral(referralFields);
      });
    }

    function _sendReferral(referral) {
      referralSvc.postReferral(referral, vm.referralSettings.settings.referralCustomFields).then(function () {
        vm.saving = !vm.saving;
        vm.completeFn();
      });
    }
  }
})();